module.exports = "/packs/banner_pc_writer-109a64eed542cd687c3b0a34ec6a9317.png";